interface PageTitlePropTypes {
  title: string
  subtitle: string
  hasViewPermission?: boolean
  className?: string
}

function PageTitle({
  title,
  subtitle,
  hasViewPermission = true,
  className = '',
}: Readonly<PageTitlePropTypes>) {
  return (
    <>
      <span
        className={`text-base font-primary font-medium ${className}`}
        data-qa-id={`${title}-heading`}
      >
        {title}
      </span>
      {hasViewPermission === false ? null : (
        <span className="text-xs font-primary font-light">{subtitle}</span>
      )}
    </>
  )
}

export default PageTitle
